import setSelectedInvoices from "@auer-steel/Store/Pages/InvoiceHistory/Handlers/SetSelectedInvoices";
import { addToChainAfter, addToEndOfChain, addToStartOfChain, replaceInChain } from "@insite/client-framework/HandlerCreator";
import updateSearchfields, {
    chain,
    DispatchUpdateLoadParameter,
} from "@insite/client-framework/Store/Pages/InvoiceHistory/Handlers/UpdateSearchFields";

export type HandlerType = Parameters<typeof DispatchUpdateLoadParameter>[0];
export type AuerInvoiceUpdateSearchFieldsParameter = Parameters<typeof updateSearchfields>[0] & {
    onComplete: () => {},
};

addToStartOfChain(chain, IncludeSerialNumberInFilters);
function AuerDispatchUpdateLoadParameter(props: HandlerType) {
    const { onComplete, ...baseParameter } = props.parameter as AuerInvoiceUpdateSearchFieldsParameter;
    props.dispatch({
        type: "Pages/InvoiceHistory/UpdateSearchFields",
        parameter: baseParameter,
    });
}
replaceInChain(chain, DispatchUpdateLoadParameter, AuerDispatchUpdateLoadParameter)
addToChainAfter(chain, DispatchUpdateLoadParameter, ClearSelectedInvoices);
addToEndOfChain(chain, DispatchOnCompleteHandler);


function ClearSelectedInvoices(props: HandlerType) {
    // AST-139
    props.dispatch(setSelectedInvoices([]));
}

function IncludeSerialNumberInFilters(props: HandlerType) {
    // AST-319
    if (props.parameter.orderTotal) {
        props = {
            ...props,
            parameter: {
                ...props.parameter,
                additionalQueryStringParameters: {
                    serialNumber: props.parameter.serialNumber,
                    jobName: props.parameter.jobName,
                    productErpNumber: props.parameter.productErpNumber,
                    orderTotalOperator: props.parameter.orderTotalOperator,
                    orderTotal: props.parameter.orderTotal
                },
            },
        };
    }
    else {
        props = {
            ...props,
            parameter: {
                ...props.parameter,
                additionalQueryStringParameters: {
                    serialNumber: props.parameter.serialNumber,
                    jobName: props.parameter.jobName,
                    productErpNumber: props.parameter.productErpNumber,
                },
            },
        };
    }
}

function DispatchOnCompleteHandler(props: HandlerType) {
    (props.parameter as AuerInvoiceUpdateSearchFieldsParameter)?.onComplete?.()
}